export const filterButton = [
  {
    id: 1,
    alt: "basketball",
    srcImg: "basketball",
    text: "Lead a healthy lifestyle",
    filterKey: "Healthy Lifestyle",
  },
  {
    id: 2,
    alt: "trophy",
    srcImg: "trophy",
    text: "Become more confident",
    filterKey: "Confidence",
  },
  {
    id: 3,
    alt: "rocket",
    srcImg: "rocket",
    text: "Achieve Goals",
    filterKey: "Achieve Goals",
  },
  {
    id: 4,
    alt: "smiling",
    srcImg: "smiling",
    text: "Reach happiness",
    filterKey: "Happiness",
  },
  {
    id: 5,
    alt: "bag",
    srcImg: "bag",
    text: "Create Wealth",
    filterKey: "Wealth",
  },
];
